import { getPermissionsForCoreUploadTypes } from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'
import { BUSINESS_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/business')({
  staticData: {
    title: 'route.coreUploadData.business',
    crumb: 'route.coreUploadData.business',
    permissions: getPermissionsForCoreUploadTypes(BUSINESS_UPLOAD_TYPES),
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route, { atLeastOne: true })
  },
})
